
/*
 *   File : transfer-ap.js
 *   Author URI : https://evoqins.com
 *   Description : Screen to transfer an AP's customers to another AP.
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { GradientButton, OutlineButton } from "../Cta";
import { Icon } from "../Icon";
import { CustomSearchSelectBox } from "../FormElements";

import style from "../../Styles/Components/delete.module.scss";

import { closeModal } from "../../Helper/helper-function";
import APIService from "../../Services/api-service";


export default function TransferAPModal(props) {
    const [apiLoader, setApiLoader] = useState(false);
    const [apList, setApList] = useState([]);
    const [selectedAp, setSelectedAp] = useState({});
    const [selectedApError, setSelectedApError] = useState("");

    useEffect(() => {
        var my_modal = document.getElementById("transfer-ap");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
        //eslint-disable-next-line
    }, [props.close]);

    useEffect(() => {
        _getApList();
        //eslint-disable-next-line
    }, []);

    function _getApList() {
        let url = 'client_mapping/ap/list';
        let payload = JSON.stringify({
            id: null
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                const modified_data = response.data.map((item) => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                });
                const aps = modified_data
                    .filter(item => item.value !== props.id);
                setApList(aps);
            } else {
                setApList([]);
            }
        })
    }

    const _selectAp = (ap) => {
        setSelectedAp(ap);
        setSelectedApError("");
    }

    function _handleButtonClick() {
        if (Object.keys(selectedAp).length === 0) {
            setSelectedApError("Please select AP");
            return;
        }
        setApiLoader(true);
        let url = 'client_mapping/ap/assign-new';
        let payload = JSON.stringify({
            id: props.id,
            new_id: selectedAp.value
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success("Customers transferred successfully");
                closeModal('transfer-ap');
                props.confirmTransfer();
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
            setApiLoader(false);
        })
    }

    return (
        <div className={`modal fade ${style.e_delete}`}
            id="transfer-ap"
            tabIndex="-1"
            aria-labelledby="transfer-ap"
            aria-hidden="true"
            data-bs-backdrop="true"
            inert>
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content bg-white text-center d-flex align-items-center padding-32px-all ${style.e_content} `}>
                    <div className="col-12 d-flex justify-content-between">
                        <Icon icon="close"
                            size={24}
                            className="cursor-pointer ms-auto e-modal-close-btn"
                            data-bs-dismiss="modal" />
                    </div>

                    <p className="color-eerie-black e-poppins-medium e-font-18 mt-2 mb-0">
                        {`Transfer all customers of ${props.name} to another AP`}
                    </p>

                    <div className="row w-100">
                        <div className="col-12 mt-4 text-start">
                            <CustomSearchSelectBox options={apList}
                                value={Object.keys(selectedAp).length === 0 ? "" : selectedAp}
                                label="Select destination AP"
                                error={selectedApError}
                                id="admin-zone"
                                hide_error_text={false}
                                placeholder=""
                                postfix="*"
                                onSelectChange={_selectAp} />
                        </div>
                    </div>

                    <div className="d-flex gap-8px margin-34px-top margin-32px-bottom  w-100 px-5">
                        <OutlineButton label="Cancel"
                            cancel="modal"
                            className="padding-12px-tb px-3 white-space-nowrap  e-font-16 e-poppins-regular " />
                        <GradientButton label="Transfer"
                            className="padding-12px-tb e-font-16 w-100 "
                            loading={apiLoader}
                            onPress={_handleButtonClick} />
                    </div>
                </div>
            </div>
        </div>
    )
}
